import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
    NavDropdown,
    Accordion,
    Card,
    Button,
    ListGroup,
    ListGroupItem
} from "react-bootstrap";
import { FileInvoiceDollar, FileInvoice } from "../Icon";
import TypeAhead from "./TypeAhead";
import NavbarLink from "./NavbarLink";
const Accounting = ({ CanI }) => {
    const [state, setState] = useState({
        invoices_add: false,
        invoices_view: false,
        vendor_bills_add: false,
        vendor_bills_view: false,
        vendor_bills_approve: false,
        reports_vendor_bill_overlay: false,
        reports_vendor_bill_payment_overlay: false,
        account_codes_add: false,
        account_codes_view: false
    });

    useEffect(() => {
        async function InitAsset() {
            setState({
                ...state,
                invoices_add: await CanI("invoices_add"),
                invoices_view: await CanI("invoices_view"),
                vendor_bills_view: await CanI("vendor_bills_view"),
                vendor_bills_add: await CanI("vendor_bills_add"),
                vendor_bills_approve: await CanI("vendor_bills_approve"),
                reports_vendor_bill_overlay: await CanI(
                    "reports_vendor_bill_overlay"
                ),
                reports_vendor_bill_payment_overlay: await CanI(
                    "reports_vendor_bill_payment_overlay"
                ),
                account_codes_add: await CanI("account_codes_add"),
                account_codes_view: await CanI("account_codes_view")
            });
        }
        InitAsset();
    }, []);
    const {
        invoices_add,
        invoices_view,
        vendor_bills_add,
        vendor_bills_approve,
        vendor_bills_view,
        reports_vendor_bill_overlay,
        reports_vendor_bill_payment_overlay,
        account_codes_add,
        account_codes_view
    } = state;

    return (
        <NavDropdown.ItemText>
            <Accordion>
                {invoices_view && (
                    <Card>
                        <Card.Header>
                            <Accordion.Toggle
                                as={Button}
                                variant="light"
                                eventKey="invoices-toggle-list"
                            >
                                <span
                                    className="text-dark"
                                    id={"invoices-toggle-list"}
                                >
                                    <FileInvoiceDollar width={17} height={17} />{" "}
                                    Invoices
                                </span>
                            </Accordion.Toggle>
                        </Card.Header>

                        <Accordion.Collapse eventKey="invoices-toggle-list">
                            <Card.Body className="p-0">
                                <ListGroup>
                                    <ListGroup.Item>
                                        <NavbarLink
                                            to="/app/invoices"
                                            className="dropdown-item"
                                            label={"View"}
                                        />
                                    </ListGroup.Item>

                                    {invoices_add && (
                                        <ListGroup.Item>
                                            <a
                                                className="dropdown-item"
                                                href="/invoices/add"
                                            >
                                                Add
                                            </a>
                                        </ListGroup.Item>
                                    )}

                                    <ListGroup.Item className="px-3">
                                        <TypeAhead
                                            component="invoices"
                                            style={{ minWidth: "150px" }}
                                            type="text"
                                            className="form-control "
                                            placeholder="Search..."
                                        />
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                )}

                {vendor_bills_view && (
                    <Card>
                        <Card.Header>
                            <Accordion.Toggle
                                as={Button}
                                variant="light"
                                eventKey="vendor_bills-toggle-list"
                            >
                                <span
                                    className="text-dark"
                                    id={"vendor_bills-toggle-list"}
                                >
                                    <FileInvoice width={17} height={17} />{" "}
                                    Vendor Bills
                                </span>
                            </Accordion.Toggle>
                        </Card.Header>

                        <Accordion.Collapse eventKey="vendor_bills-toggle-list">
                            <Card.Body className="p-0">
                                <ListGroup>
                                    <ListGroup.Item>
                                        <NavbarLink
                                            to="/app/vendor_bills"
                                            className="dropdown-item"
                                            label={"View"}
                                        />
                                    </ListGroup.Item>

                                    {vendor_bills_add && (
                                        <ListGroup.Item>
                                            <NavbarLink
                                                to="/app/vendor_bills/add"
                                                className="dropdown-item"
                                                label={"Add"}
                                            />
                                        </ListGroup.Item>
                                    )}
                                    {vendor_bills_approve && (
                                        <ListGroup.Item>
                                            <NavbarLink
                                                to="/app/vendor_bills/approve"
                                                className="dropdown-item"
                                                label={"Approve"}
                                            />
                                        </ListGroup.Item>
                                    )}

                                    <ListGroup.Item>
                                        {reports_vendor_bill_overlay ||
                                        reports_vendor_bill_payment_overlay ? (
                                                <Accordion>
                                                    <Card>
                                                        <Card.Header>
                                                            <Accordion.Toggle
                                                                as={Button}
                                                                variant="light"
                                                                eventKey="vendor_bills_overlay-toggle-list"
                                                            >
                                                                <span className="text-dark">
                                                                Vendor Bills
                                                                Overlay
                                                                </span>
                                                            </Accordion.Toggle>
                                                        </Card.Header>

                                                        <Accordion.Collapse eventKey="vendor_bills_overlay-toggle-list">
                                                            <Card.Body>
                                                                {reports_vendor_bill_overlay && (
                                                                    <ListGroup>
                                                                        <ListGroupItem>
                                                                            <a
                                                                                className="dropdown-item confirmVendorBillOverlay"
                                                                                data-name="Vendor Bill Overlay"
                                                                                data-id=""
                                                                                data-toggle="modal"
                                                                                href="#modal-confirm"
                                                                            >
                                                                            Vendor
                                                                            Bill
                                                                            Overlay
                                                                            </a>
                                                                        </ListGroupItem>
                                                                        <ListGroupItem>
                                                                            <a
                                                                                className="dropdown-item"
                                                                                href="/reports/vendor-bill-overlay/template"
                                                                            >
                                                                            Download
                                                                            Vendor
                                                                            Bill
                                                                            Overlay
                                                                            Template
                                                                            </a>
                                                                        </ListGroupItem>
                                                                    </ListGroup>
                                                                )}
                                                                {reports_vendor_bill_payment_overlay && (
                                                                    <ListGroup>
                                                                        <ListGroup.Item>
                                                                            <a
                                                                                className="dropdown-item confirmVendorBillPaymentOverlay"
                                                                                data-name="Vendor Bill Payment Overlay"
                                                                                data-id=""
                                                                                data-toggle="modal"
                                                                                href="#modal-confirm"
                                                                            >
                                                                            Vendor
                                                                            Bill
                                                                            Payment
                                                                            Overlay
                                                                            </a>
                                                                        </ListGroup.Item>
                                                                        <ListGroup.Item>
                                                                            <a
                                                                                className="dropdown-item"
                                                                                href="/reports/vendor-bill-payment-overlay/template"
                                                                            >
                                                                            Download
                                                                            Vendor
                                                                            Bill
                                                                            Payment
                                                                            Overlay
                                                                            Template
                                                                            </a>
                                                                        </ListGroup.Item>
                                                                    </ListGroup>
                                                                )}
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                </Accordion>
                                            ) : null}
                                    </ListGroup.Item>

                                    <ListGroup.Item className="px-3">
                                        <TypeAhead
                                            component="vendor_bills"
                                            style={{ minWidth: "150px" }}
                                            type="text"
                                            className="form-control "
                                            placeholder="Search..."
                                        />
                                    </ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                )}

                {account_codes_view && (
                    <Card>
                        <Card.Header>
                            <Accordion.Toggle
                                as={Button}
                                variant="light"
                                eventKey="account-codes-toggle-list"
                            >
                                <span className="text-dark">
                                    {/* <FileInvoiceDollar width={17} height={17} />{" "}*/}
                                    Account Codes
                                </span>
                            </Accordion.Toggle>
                        </Card.Header>

                        <Accordion.Collapse eventKey="account-codes-toggle-list">
                            <Card.Body className="p-0">
                                <ListGroup>
                                    <ListGroup.Item>
                                        <NavbarLink
                                            to="/app/account_codes"
                                            className="dropdown-item"
                                            label={"View"}
                                        />
                                    </ListGroup.Item>

                                    {account_codes_add && (
                                        <ListGroup.Item>
                                            <a
                                                className="dropdown-item"
                                                href="/app/account_codes/add"
                                            >
                                                Add
                                            </a>
                                        </ListGroup.Item>
                                    )}
                                </ListGroup>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                )}
            </Accordion>
        </NavDropdown.ItemText>
    );
};

Accounting.propTypes = { CanI: PropTypes.func };

export default Accounting;